import * as React from 'react';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { getCurrency, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { INVOICE_STATUS_DISPLAY_NAMES } from '../../constants/InvoiceStatuses';
import InvoiceDisplayStatusDisplay from '../invoice_display_status_display/InvoiceDisplayStatusDisplay';
import DateTimeHover from '../date_time_component/DateTime';
import { getContactName } from '../../utils/DataFormatterUtils';
import { getSanitisedWorkOrder } from '../../utils/WorkOrderUtils';
import { getInvoiceOtherCompanyEntity } from '../invoice_utilities/InvoiceUtilities';

require('./InvoiceRowDisplay.less');

export const InvoiceRowDisplay: React.FC<any> = ({ invoice, currentUser, ...props }) => {
	const wo = getSanitisedWorkOrder(nullSafeGetOrElse('workOrder', invoice, {}));
	const otherFacility = getInvoiceOtherCompanyEntity(invoice, currentUser);

	return (
		<div className="invoiceRowDisplay" {...props}>
			<div className="rowColumn">
				<div className="rowPrimary" style={{ color: 'rgba(0,0,0,0.65)' }}>
					<Ellipsis
						tooltip={true}
						fullWidthRecognition={true}
						lines={1}
						style={{ paddingBottom: '1px' }}
					>
						{wo.title}
					</Ellipsis>
				</div>
				<div className="rowSecondary">
					<div className="rowInlineGroup" style={{ display: 'inline-flex' }}>
						<span className="rowGrayChip">
							<i className="icons8-font icons8-location-marker" />
							<span>{nullSafeGet('location.name', wo)}</span>
						</span>
					</div>
					<div className="rowInlineGroup" style={{ display: 'inline-flex' }}>
						<InvoiceDisplayStatusDisplay status={INVOICE_STATUS_DISPLAY_NAMES[invoice.status]} />
					</div>
					{nullSafeGet('isCapex', wo) ? (
						<div className="rowInlineGroup" style={{ display: 'inline-flex' }}>
							<span className={'rowGrayChip'} style={{ padding: '4px 12px', borderRadius: 16 }}>
								<span>CapEx</span>
							</span>
						</div>
					) : null}
					<div className="rowInlineGroup" style={{ display: 'inline-flex' }}>
						<i className="icons8-font icons8-maintenance-filled" />
						<span>{nullSafeGet('problemType.hierarchyName', wo)}</span>
					</div>
					{nullSafeGet('displayName', otherFacility) ? (
						<div className="rowInlineGroup" style={{ display: 'inline-flex' }}>
							<i className="icons8-font icons8-company" />
							{nullSafeGet('displayName', otherFacility)}
						</div>
					) : null}
					{nullSafeGet('glCode', invoice) ? (
						<div className="rowInlineGroup">
							{'GL Code: '.concat(nullSafeGet('glCode', invoice))}
						</div>
					) : null}
					<div className="rowInlineGroup">{`Invoice #${nullSafeGetOrElse(
						'invoiceNumber',
						invoice,
						'--'
					)}`}</div>
					<div className="rowInlineGroup">{'WO #'.concat(nullSafeGet('id', wo))}</div>
					{nullSafeGet('buyerProjects.length', wo) === 1 ? (
						<div className="rowInlineGroup" style={{ display: 'inline-flex' }}>
							<span>
								<i className="icons8-font icons8-blueprint" />
								{nullSafeGet('buyerProjects', wo)[0].title}
							</span>
						</div>
					) : nullSafeGet('buyerProjects.length', wo) > 1 ? (
						<div className="rowInlineGroup" style={{ display: 'inline-flex' }}>
							<span>
								<i className="icons8-font icons8-blueprint" />
								{nullSafeGet('buyerProjects.length', wo)} Projects
							</span>
						</div>
					) : null}
				</div>
				<div className="rowTertiary rowBlackPrimary mt-2">
					<span style={{ whiteSpace: 'nowrap', color: 'rgba(0,0,0,0.45)', fontSize: 14 }}>
						<>
							Submitted{' '}
							<DateTimeHover
								timestamp={nullSafeGet('createdAt', invoice)}
								showTime={false}
								timeZone={nullSafeGet('location.timeZoneId', invoice)}
							/>{' '}
							{invoice.createdByContact ? `by ${getContactName(invoice.createdByContact)}` : ''}
						</>
					</span>
				</div>
			</div>
			<div className="invoiceRowDisplay__rightSide">
				<div className="invoiceRowDisplay__rowInlineGroup">
					{getCurrency({ workOrder: wo }).format(invoice.invoiceTotalAfterTax)}
				</div>
			</div>
		</div>
	);
};
